import React, { useState } from "react";
import { routes } from "../../config/utilities/utils.constant";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileAppsHeader";

const navItems = [
  { label: "Home", link: routes.HOME },
  { label: "About Us", link: routes.ABOUTUS },
  {
    label: "Services",
    link: "#",
    subItems: [
      { label: "Mobile App Development", link: routes.MOBILEAPPLICATIONDEVELOPMENT,
        children: [
          { label: "Cross-Platform Mobile App Development", link: routes.CROSSPLATFORMMOBILEAPPDEVELOPMENT },
          { label: "Native Mobile App Development", link: routes.NATIVEAPPDEVELOPMENT },
        ],
       },
      // { label: "Native Mobile Application Development", link: routes.NATIVEAPPLICATIONS },
      // { label: " IoT Application Development", link: routes.IOTAPPLICATIONS },
      { label: " IoT Development", link: routes.IOTDEVELOPMENTSERVICE },
      { label: "Web Application Development ",  link: routes.WEBAPPS},
      { label: "Graphic and UI/UX Designing",  link: routes.GRAPHICANDUIUXDESIGNING},
      { label: "CMS Development", link: routes.CMSDEVELOPMENT },
      { label: "Digital Marketing", link: routes.DIGITALMARKETING ,
         children: [
          { label: "Search Engine Optimization", link: routes.SEARCHENGINEOPTIMIZATION },
         ],
      },
      { label: "AI Integrations and Chatbots", link: routes.AIINTEGRATIONSANDCHATBOTS },
    ],
  },
  { label: "Blogs", link: routes.BLOGS },
  { label: "Contact Us", link: routes.CONTACTUS },
];

function Header({ gradient = false,glassEffect=false ,darkText,seoPage }) { 
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const [openSubmenuIndex, setOpenSubmenuIndex] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);  
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  const toggleMenuOpen = () => {
    if (isProcessing) return; // Prevents further clicks while processing
  
    setIsProcessing(true);  
    setShouldRender(true);
    setIsMenuOpen(true);
  
    setTimeout(() => {
      setIsProcessing(false);
    }, 200); 
  };
  
  const toggleMenuClose = () => {
    if (isProcessing) return; 
  
    setIsProcessing(true);  
    setIsMenuOpen(false);
    setIsSubMenuOpen(false);
  
    setTimeout(() => {
      setOpenSubmenuIndex(null);
      setShouldRender(false);
      setIsProcessing(false);  
    }, 200); 
  };
  
 

 


  return (
    <>
  
      {/* Header for desktop */}
    <DesktopHeader glassEffect={glassEffect} seoPage={seoPage}  gradient = {gradient} navItems={navItems}  toggleMenuOpen={toggleMenuOpen } isMenuOpen={isMenuOpen} darkText = {darkText}/>

      {/* Header for mobile apps */}
     <MobileHeader   navItems={navItems} toggleMenuClose={toggleMenuClose} shouldRender ={shouldRender} setShouldRender={setShouldRender} isMenuOpen={isMenuOpen} setIsMenuOpen ={setIsMenuOpen} isSubMenuOpen ={isSubMenuOpen} setIsSubMenuOpen={setIsSubMenuOpen} openSubmenuIndex={openSubmenuIndex}setOpenSubmenuIndex={setOpenSubmenuIndex}
     />
    </>
  );
}

export default Header;
